export { toBooleanFromBit } from '../../product/utils/productHelpers';

export const CONTENT_TYPE_OPTIONS = [
  { value: 'spec_group_sidebar', label: 'Spec group sidebar' },
  { value: 'spec_group_table', label: 'Spec group table' },
  { value: 'spec_groups_table', label: 'Spec groups table' },
  { value: 'vendor_block', label: 'Vendor block' },
  { value: 'review_block', label: 'Review block' },
];

export const PLACEMENT_OPTIONS = [
  { value: 'tab', label: 'Tab' },
  { value: 'sidebar', label: 'Sidebar' },
];

export const DEFAULT_CONTENT_CONFIG_BY_TYPE = {
  spec_group_sidebar: { specGroup: 'General Info' },
  spec_group_table: { specGroup: 'Description' },
  spec_groups_table: { excludeSpecGroups: ['General Info', 'Description'] },
  vendor_block: {},
  review_block: {},
};

export const getDefaultContentConfig = (contentType) =>
  DEFAULT_CONTENT_CONFIG_BY_TYPE[contentType] || {};

export const getDefaultPlacementForType = (contentType) =>
  contentType === 'spec_group_sidebar' ? 'sidebar' : 'tab';

export const formatContentConfigForView = (config) => {
  if (!config || typeof config !== 'object') return '-';
  try {
    return JSON.stringify(config);
  } catch {
    return '-';
  }
};
